export
const name: string = "Points";

export
const preproc: string = ``;

export
const declaration: string = `
    // override default precision specified in defaultPrecision_fs
    precision lowp float;
    precision lowp int;

    uniform vec2      u_glyph_size;
    uniform sampler2D u_texture;

    #if !defined(DEPTH_PASS) && !defined(PRIMITIVE_ID_PASS)
    uniform int       u_texture_model;
    uniform vec3      u_texture_blend_color;
    #endif

    #if !defined(DEPTH_PASS) && !defined(PRIMITIVE_ID_PASS)
    uniform SMaterial u_material;
    #endif
`;

export
const varyings: string = `
    varying mediump vec2 v_tex_coord;

    #if defined(PRIMITIVE_ID_PASS)
    varying vec4 v_primitive_id;
    #endif

    #if !defined(DEPTH_PASS) && !defined(PRIMITIVE_ID_PASS)
    varying float v_selected;
    #endif
`;

export
const implementation: string = `
    void main(void)
    {
        #ifdef CLIPPING_PLANE

        resolveClippingPlane();

        #endif

        vec4 resColor;

        vec4 texColor = texture2D(u_texture, v_tex_coord + ((gl_PointCoord.xy * u_glyph_size)));

        if (texColor.a < 0.2) discard;

    #if !defined(DEPTH_PASS) && !defined(PRIMITIVE_ID_PASS)
        if (u_texture_model == TEX_MODEL_BLEND) {
            resColor = vec4(texColor.rgb * u_texture_blend_color, texColor.a);
        }
        else if (u_texture_model == TEX_MODEL_MODULATE) {
            resColor = vec4(texColor.rgb * u_material.diffuse, texColor.a);
        }
        else if (u_texture_model == TEX_MODEL_REPLACE) { // replace
            resColor = texColor;
        }
        else {
            resColor = vec4(1.0);
        }

        if (v_selected > 0.5) {
            resColor.rgb = clamp(resColor.rgb + vec3(0.6), 0.0, 1.0) * u_selected_material_diffuse;
        }

        gl_FragColor = resColor;

        #ifdef LOGDEPTH

        resolveLogarithmicDepth();

        #endif

    #endif

    #if defined(DEPTH_PASS)

        float z = gl_FragCoord.z;
        gl_FragColor = floatToVec4(z);

    #elif defined(PRIMITIVE_ID_PASS)

        gl_FragColor = v_primitive_id;

    #endif
    }
`;
